import { render, staticRenderFns } from "./invoice_list.vue?vue&type=template&id=153b0f3a&scoped=true"
import script from "./invoice_list.vue?vue&type=script&lang=js"
export * from "./invoice_list.vue?vue&type=script&lang=js"
import style0 from "./invoice_list.vue?vue&type=style&index=0&id=153b0f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153b0f3a",
  null
  
)

export default component.exports